import styled from 'styled-components'

export const StyledRoot = styled.div`
  display: grid;
  grid-template-columns: 414px 1fr;
  grid-column-gap: 53px;
  @media (max-width: 1400px) {
    grid-template-columns: unset;
    grid-auto-flow: row;
  }
`

export const StyledLeftSide = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 30px;
  row-gap: 15px;
  grid-auto-rows: max-content;
`

export const StyledRightSide = styled.div``
